import React from 'react';
import { Layout } from '@/layout/indexLayout';
import { SimpleLayout } from '@/layout/simpleLayout';
import { NoPage } from '@/views/noPage';
import { LazyImportComponent } from '@/components/LazyImportComponent';

const HomeLazy = React.lazy(() => import('@/views/home/Home'));
const ChatLazy = React.lazy(() => import('@/views/chat'));
const CreativityLazy = React.lazy(() => import('@/views/creativity'));
const LearnLazy = React.lazy(() => import('@/views/learn'));
const LoginLazy = React.lazy(() => import('@/views/user/login'));
const ToolsLazy = React.lazy(() => import('@/views/tools'));
const UserProfileLazy = React.lazy(() => import('@/views/user/profile').then(({ UserSettings }) => ({ default: UserSettings })));
const UserSettingsLazy = React.lazy(() => import('@/views/user/settings'));
const RechargeRecordsLazy = React.lazy(() => import('@/views/user/rechargeRecords').then(({ RechargeRecords }) => ({ default: RechargeRecords })));
const RechargeLazy = React.lazy(() => import('@/views/user/recharge').then(({ Recharge }) => ({ default: Recharge })));
const TermsLazy = React.lazy(() => import('@/views/terms'));
const PrivacyLazy = React.lazy(() => import('@/views/privacy'));

export const routes = [
	{
		path: '/user/login',
		element: <LazyImportComponent lazyChildren={LoginLazy} />,
	},
	{
		path: '/user',
		element: <SimpleLayout />,
		children: [
			{
				path: 'settings',
				element: <LazyImportComponent lazyChildren={UserSettingsLazy} />,
			},
			{
				path: 'profile',
				element: <LazyImportComponent lazyChildren={UserProfileLazy} />,
			},
			{
				path: 'recharge-records',
				element: <LazyImportComponent lazyChildren={RechargeRecordsLazy} />,
			},
			{
				path: 'recharge',
				element: <LazyImportComponent lazyChildren={RechargeLazy} />,
			},
			{
				path: 'terms',
				element: <LazyImportComponent lazyChildren={TermsLazy} />,
			},
			{
				path: 'privacy',
				element: <LazyImportComponent lazyChildren={PrivacyLazy} />,
			}
		]
	},
	{
		path: '/',
		element: <Layout />,
		children: [
			{
				path: '/',
				element: <LazyImportComponent lazyChildren={HomeLazy} />,
			},
			{
				path: '/chat',
				element: <LazyImportComponent lazyChildren={ChatLazy} />,
			},
			{
				path: '/chat/:id',
				element: <LazyImportComponent lazyChildren={ChatLazy} />,
			},
			{
				path: '/tools',
				element: <LazyImportComponent lazyChildren={ToolsLazy} />,
			},
			{
				path: '/creativity',
				element: <LazyImportComponent lazyChildren={CreativityLazy} />,
			},
			{
				path: '/learn',
				element: <LazyImportComponent lazyChildren={LearnLazy} />,
			},
		],
	},
	{
		path: '*',
		element: <NoPage />,
	}
];